import styled from '@emotion/styled';
import { colors } from "../../../../common/styles/theme.styles";

export const VaultMobileContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const VaultMobileContent = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const VaultMobileListHeader = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 48px;
    padding: 8px 16px;
    align-items: center;
    justify-content: space-between;

    color: var(--Dark-Gray-3, #9097A3);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    border-bottom: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
    background: #FFFFFF;
`;

export const VaultMobileListHeaderSortButton = styled.div`
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 4px;

    border-radius: 8px;
    color: var(--Dark-Gray-2, #585D66);
    border: 1px solid transparent;

    cursor: pointer;
    min-height: 32px;

    &:hover {
        border: 1px solid ${colors.gray3};
    }

    /* Mobile-specific optimizations */
    @media (max-width: 768px) {
        padding: 10px 12px;
        min-height: 36px;
        font-size: 14px;
    }
`;

export const VaultMobileListHeaderSortDirectionButton = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 2px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    border-radius: 20px;

    &:hover {
        background: var(--Main-Colors-Light-Grey-2, #F1F3F5);
    }

    ${({ sortDirection }) => (sortDirection === -1) && `
        transform: rotate(180deg);
    `}

    user-select: none;

    /* Mobile-specific optimizations */
    @media (max-width: 768px) {
        width: 24px;
        height: 24px;
        padding: 4px;
    }
`;

export const VaultMobileHeaderContainer = styled.div`
    padding: 12px 16px;
    overflow: hidden;
    background-color: #fff;
`;

export const VaultMobileHeaderTitle = styled.div`
    color: #374151;
    font-size: 14px;
    font-weight: 450;
    margin-bottom: 16px;
`;

export const VaultMobileSearchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    
    > div:first-of-type {
        flex: 1;
    }
`;

export const VaultMobileHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
`;

export const VaultMobileFiltersWrapper = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    max-width: 100%;
    
    /* Let the VaultFilters component handle its own scrolling logic */
    > div {
        flex: 1;
        min-width: 0;
        max-width: 100%;
    }
`;

export const VaultMobileFileListContainer = styled.div`
    padding: 0;
`;

export const VaultMobileFileItem = styled.div`
    display: flex;
    align-items: center;
    padding: 16px;
    background: #FFFFFF;
    border-bottom: 1px solid #E5E7EB;
    cursor: pointer;
    transition: background-color 0.2s;
    min-height: 64px;
    
    &:hover {
        background: #F9FAFB;
    }
    
    &:last-child {
        border-bottom: none;
    }
`;

export const VaultMobileFileIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
`;

export const VaultMobileFileInfo = styled.div`
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const VaultMobileFileName = styled.div`
    color: #111827;
    font-size: 16px;
    font-weight: 450;
    line-height: 20px;
    word-break: break-word;
    
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    
    width: 100%;
    max-height: 40px;
`;

export const VaultMobileFileDetails = styled.div`
    color: #6B7280;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const VaultMobileFileActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const VaultMobileFileStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
`;

export const VaultMobileRightArrow = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
`;

export const VaultMobileEmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 64px 32px;
    text-align: center;
    color: #6B7280;
`;

export const VaultMobileEmptyTitle = styled.div`
    color: #111827;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 8px;
`;

export const VaultMobileEmptyDescription = styled.div`
    font-size: 14px;
    line-height: 1.5;
`; 